import {memo} from 'react';
import {AssetIconProps} from '../types';

export const AssetIconTeams = memo(({size = 20}: AssetIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="teams-grad1" cx="-565.04" cy="414.96" r="1" gradientTransform="translate(7651.62 13823.75) scale(13.48 -33.27)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#a98aff"/>
          <stop offset=".14" stopColor="#8c75ff"/>
          <stop offset=".56" stopColor="#5f50e2"/>
          <stop offset=".9" stopColor="#3c2cb8"/>
        </radialGradient>
        <radialGradient id="teams-grad2" cx="-589.88" cy="440.74" r="1" gradientTransform="translate(-6356.17 23377.06) rotate(68.15) scale(32.75 -33.12)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#85c2ff"/>
          <stop offset=".69" stopColor="#7588ff"/>
          <stop offset="1" stopColor="#6459fe"/>
        </radialGradient>
        <linearGradient id="teams-grad3" x1="17" y1="-56" x2="17" y2="-80" gradientTransform="translate(0 -42) scale(1 -1)" gradientUnits="userSpaceOnUse">
          <stop offset=".8" stopColor="#6864f6" stopOpacity="0"/>
          <stop offset="1" stopColor="#5149de"/>
        </linearGradient>
        <radialGradient id="teams-grad4" cx="-600.17" cy="477.06" r="1" gradientTransform="translate(-11301.88 7690.76) rotate(113.33) scale(19.22 -15.43)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#bd96ff"/>
          <stop offset=".69" stopColor="#bd96ff" stopOpacity="0"/>
        </radialGradient>
        <radialGradient id="teams-grad5" cx="-656.7" cy="380.99" r="1" gradientTransform="translate(4837.67 -6559.43) rotate(-90) scale(10 -12.62)" gradientUnits="userSpaceOnUse">
          <stop offset=".27" stopColor="#6868f7"/>
          <stop offset="1" stopColor="#3923b1"/>
        </radialGradient>
        <radialGradient id="teams-grad6" cx="-503.04" cy="432.14" r="1" gradientTransform="translate(-97.64 5738.9) rotate(40.05) scale(7.15 -10.34)" gradientUnits="userSpaceOnUse">
          <stop offset=".27" stopColor="#a1d3ff"/>
          <stop offset=".81" stopColor="#a1d3ff" stopOpacity="0"/>
        </radialGradient>
        <radialGradient id="teams-grad7" cx="-593.28" cy="393" r="1" gradientTransform="translate(9261.24 2780.96) rotate(-41.66) scale(8.51 -20.88)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#e3acfd"/>
          <stop offset=".82" stopColor="#9fa2ff" stopOpacity="0"/>
        </radialGradient>
        <radialGradient id="teams-grad8" cx="-648.92" cy="388.99" r="1" gradientTransform="translate(5905.63 -7782.71) rotate(-90) scale(12 -15.15)" gradientUnits="userSpaceOnUse">
          <stop offset=".27" stopColor="#8282ff"/>
          <stop offset="1" stopColor="#3923b1"/>
        </radialGradient>
        <radialGradient id="teams-grad9" cx="-520.87" cy="431.62" r="1" gradientTransform="translate(-16.76 6975.25) rotate(40.05) scale(8.58 -12.4)" gradientUnits="userSpaceOnUse">
          <stop offset=".27" stopColor="#a1d3ff"/>
          <stop offset=".81" stopColor="#a1d3ff" stopOpacity="0"/>
        </radialGradient>
        <radialGradient id="teams-grad10" cx="-596.07" cy="399" r="1" gradientTransform="translate(11213.89 3425.76) rotate(-41.66) scale(10.22 -25.06)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#e3acfd"/>
          <stop offset=".82" stopColor="#9fa2ff" stopOpacity="0"/>
        </radialGradient>
        <radialGradient id="teams-grad11" cx="-576.47" cy="433.34" r="1" gradientTransform="translate(2290 16175.99) rotate(45) scale(22.63 -22.63)" gradientUnits="userSpaceOnUse">
          <stop offset=".05" stopColor="#688eff"/>
          <stop offset=".95" stopColor="#230f94"/>
        </radialGradient>
        <radialGradient id="teams-grad12" cx="-568.3" cy="475.37" r="1" gradientTransform="translate(-6205.12 6393.6) rotate(90) scale(11.2 -13.07)" gradientUnits="userSpaceOnUse">
          <stop offset=".57" stopColor="#6965f6" stopOpacity="0"/>
          <stop offset="1" stopColor="#8f8fff"/>
        </radialGradient>
      </defs>
      <path d="M18,16h12c3.31,0,6,2.69,6,6v10c0,3.31-2.69,6-6,6s-6-2.69-6-6v-10c0-3.31-2.69-6-6-6Z" fill="url(#teams-grad1)"/>
      <path d="M4,20c0-3.31,2.69-6,6-6h8c3.31,0,6,2.69,6,6v12c0,3.31,2.69,6,6,6H14c-5.52,0-10-4.48-10-10v-8Z" fill="url(#teams-grad2)"/>
      <path d="M4,20c0-3.31,2.69-6,6-6h8c3.31,0,6,2.69,6,6v12c0,3.31,2.69,6,6,6H14c-5.52,0-10-4.48-10-10v-8Z" fill="url(#teams-grad3)" fillOpacity=".7"/>
      <path d="M4,20c0-3.31,2.69-6,6-6h8c3.31,0,6,2.69,6,6v12c0,3.31,2.69,6,6,6H14c-5.52,0-10-4.48-10-10v-8Z" fill="url(#teams-grad4)" fillOpacity=".7"/>
      <path d="M29,14c2.76,0,5-2.24,5-5s-2.24-5-5-5-5,2.24-5,5,2.24,5,5,5Z" fill="url(#teams-grad5)"/>
      <path d="M29,14c2.76,0,5-2.24,5-5s-2.24-5-5-5-5,2.24-5,5,2.24,5,5,5Z" fill="url(#teams-grad6)" fillOpacity=".46"/>
      <path d="M29,14c2.76,0,5-2.24,5-5s-2.24-5-5-5-5,2.24-5,5,2.24,5,5,5Z" fill="url(#teams-grad7)" fillOpacity=".4"/>
      <path d="M14,12c3.31,0,6-2.69,6-6S17.31,0,14,0s-6,2.69-6,6,2.69,6,6,6Z" fill="url(#teams-grad8)"/>
      <path d="M14,12c3.31,0,6-2.69,6-6S17.31,0,14,0s-6,2.69-6,6,2.69,6,6,6Z" fill="url(#teams-grad9)" fillOpacity=".6"/>
      <path d="M14,12c3.31,0,6-2.69,6-6S17.31,0,14,0s-6,2.69-6,6,2.69,6,6,6Z" fill="url(#teams-grad10)" fillOpacity=".5"/>
      <rect y="19" width="16" height="16" rx="3.25" ry="3.25" fill="url(#teams-grad11)"/>
      <rect y="19" width="16" height="16" rx="3.25" ry="3.25" fill="url(#teams-grad12)" fillOpacity=".7"/>
      <path d="M11.48,24.11h-2.45v7.47h-2.06v-7.47h-2.45v-1.68h6.96v1.68Z" fill="#fff"/>
    </svg>
  );
});


